module.exports = __webpack_public_path__ + "assets/bg-image-auth-left.jpg";